import {
  Button,
  Divider,
  OutlinedInput,
  Stack,
  Typography
} from '@mui/material'
import { Copy as CopyIcon } from '@phosphor-icons/react'

interface Props {
  inviteLink: string
  onCopyInviteLinkClick: () => void
}

const Empty = () => null

function ShareLink(props: Props) {
  const { onCopyInviteLinkClick, inviteLink = '' } = props

  return (
    <>
      <Stack
        style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
        direction='column'
        spacing={2}
      >
        <Stack spacing={1}>
          <Typography variant='h6'>Invite members</Typography>
          <Typography
            color='text.secondary'
            variant='body2'
          >
            Members can view, create, edit and delete maps.
          </Typography>
        </Stack>
        <OutlinedInput
          name='name'
          type='text'
          value={inviteLink}
          readOnly
        />
        <Stack
          sx={{
            justifyContent: 'flex-start',
            display: 'flex'
          }}
        >
          <Button
            sx={{ width: 120, alignSelf: 'flex-start' }}
            startIcon={<CopyIcon fill='#fff' />}
            data-testid='InviteButton'
            onClick={onCopyInviteLinkClick}
          >
            Copy invite link
          </Button>
        </Stack>
        <Divider />
        {/* <Stack
          direction='row'
          spacing={2}
        >
          {<Slots.Duplicate />}
          {<Slots.InfographicButton />}
          {<Slots.EmbedButton />}
        </Stack>
        {isOwner && (
          <Stack
            sx={{
              flexGrow: 1,
              justifyContent: 'flex-end',
              display: 'flex'
            }}
          >
            <Button
              sx={{ width: 120, alignSelf: 'flex-end' }}
              color='inherit'
              startIcon={<ShareIcon />}
              onClick={onManageAccess}
            >
              Manage access
            </Button>
          </Stack>
        )} */}
      </Stack>
    </>
  )
}

export { ShareLink }
